import { javascriptLanguage } from "@codemirror/lang-javascript";
import { createCompletionsFromSchema } from "./autocomplete.utils";

const useCodeEditorCompletions = (completionSchema) => {
  if (!completionSchema) {
    return {};
  }

  const allCompletions = createCompletionsFromSchema(completionSchema);

  const customCompletionSource = (context) => {
    const word = context.matchBefore(/[\w.]*/);

    if (!word) {
      return null;
    }

    const textBefore = context.state.doc.sliceString(0, context.pos);
    const dotMatch = textBefore.match(/([\w.]+)\.(\w*)$/);

    if (dotMatch) {
      const [, prefix, partial] = dotMatch;
      const filtered = allCompletions.filter(comp => {
        const path = comp.info || "";
        return path.startsWith(prefix + ".") &&
          path.indexOf(".", prefix.length + 1) === -1;
      });

      if (filtered.length > 0) {
        return {
          from: context.pos - partial.length,
          options: filtered,
          validFor: /^\w*$/
        };
      }
    } else if (context.explicit || word.text.length > 0) {
      const filtered = allCompletions.filter(comp => !comp.info.includes("."));
      if (filtered.length > 0) {
        return {
          from: word.from,
          options: filtered,
          validFor: /^\w*$/
        };
      }
    }

    return null;
  };

  const javascriptExtension = javascriptLanguage.data.of({
    autocomplete: customCompletionSource
  });

  return {
    javascriptAutocomplete: javascriptExtension
  };
};

export default useCodeEditorCompletions;
